export default __webpack_public_path__ + "static/media/sony.2c8d6f61.webp";